import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import {
  FormCheck,
  FormCombobox,
  FormInput,
  FormSelect,
  FormText,
  Headline,
  If,
  isEmptyObj,
  actions,
  appActions,
  SummingUp,
  BegleitdatenModalNeuesModell,
  PrevNextButton,
  useNextPage,
  useUpdateAndValidateOnChange,
  usePrevPage,
} from 'ion-lib';
import SummingUpInhalt from '../../components/SummingupWarenkorb';
import { getBannerFileName } from '../../helper';

const EmpfehlungBerater = () => {
  const dispatch = useDispatch();
  const euBeratung = useSelector((state) => state.euBeratung);
  const validateOnChange = useUpdateAndValidateOnChange();
  const nextPage = useNextPage();
  const prevPage = usePrevPage();

  useEffect(() => {
    dispatch(appActions.serverValidationRequest('validiere', [
      'spkBegleitdaten.vertragsabschliessendeOE',
      'spkBegleitdaten.mitarbeiterOE',
      'spkBegleitdaten.personalnummerBerater',
    ], () => null));
  }, []);

  const handleNextClick = () => {
    dispatch(appActions.beratungRequest('validiereBeratungsdoku', (state) => {
      const {
        freitext,
        empfehlungAngenommen,
        empfehlung,
      } = state.euBeratung.versicherungsProduktStruktur[0];

      if (!freitext.meldungen && !empfehlungAngenommen.meldungen && !empfehlung.meldungen) {
        dispatch(appActions.serverValidationRequest('validiere', [
          'spkBegleitdaten.vertragsabschliessendeOE',
          'spkBegleitdaten.mitarbeiterOE',
          'spkBegleitdaten.personalnummerBerater',
        ], () => {
          nextPage();
        }));
      }
    }));
  };

  const aktualisiereBeratungsdokuMeta = () => dispatch(appActions.beratungRequest('aktualisiereBeratungsdoku'));

  if (isEmptyObj(euBeratung)) {
    dispatch(appActions.holeVorbelegungenBeratungsdoku(() => {
      prevPage();
    }));

    return (
      <Row>
        <Col>
          <div>
            <Headline>Empfehlungen des Beraters</Headline>
          </div>

          <Row>
            <Col>
              <PrevNextButton
                className="d-md-none oev-show spk-show"
              />
            </Col>
          </Row>
        </Col>
        <SummingUp bannerImg={getBannerFileName}>
          <SummingUpInhalt />
          <BegleitdatenModalNeuesModell onChange={validateOnChange} />
        </SummingUp>
      </Row>
    );
  }

  const produktStruktur = euBeratung.versicherungsProduktStruktur[0];

  const weitereProdukte = produktStruktur.produktbausteinNichtVorbelegt.map((produkt, index) => ({
    id: produkt.nameMText,
    index,
    bezeichnung: produkt.nameAnwendung,
    ausgewaehlt: produkt.ausgewaehlt,
  }));

  return (
    <Row>
      <Col>
        <div className="spkpanel">
          <Headline>Empfehlungen des Beraters</Headline>
          <div className="euberatung-inline-checkboxes">
            {produktStruktur.produktbausteinVorbelegt.map((baustein, index) => (
              <FormCheck
                key={baustein.nameAnwendung}
                value={baustein.ausgewaehlt}
                label={baustein.nameAnwendung}
                name={`euBeratung.versicherungsProduktStruktur.0.produktbausteinVorbelegt.${index}.ausgewaehlt`}
                onChange={(e) => dispatch(actions.updateByEvent(e, aktualisiereBeratungsdokuMeta))}
                ueberschreibbar
                customClass="d-md-inline-block d-md-w-50"
              />
            ))}
          </div>

          <FormCombobox
            label="Weitere Produktempfehlungen"
            valueSet={weitereProdukte}
            isMulti
            ueberschreibbar
            onChange={(selected, type) => {
              if (type.action === 'select-option') {
                dispatch(actions.updateByName(`euBeratung.versicherungsProduktStruktur.0.produktbausteinNichtVorbelegt.${type.option.index}.ausgewaehlt`, true));
                dispatch(actions.updateByName('euBeratung.versicherungsProduktStruktur.0.empfehlungAngenommen.value.id', 1, aktualisiereBeratungsdokuMeta));
              } else if (type.action === 'remove-value') {
                dispatch(actions.updateByName(`euBeratung.versicherungsProduktStruktur.0.produktbausteinNichtVorbelegt.${type.removedValue.index}.ausgewaehlt`, false));
                dispatch(actions.updateByName('euBeratung.versicherungsProduktStruktur.0.empfehlungAngenommen.value.id', 2, aktualisiereBeratungsdokuMeta));
              } else if (type.action === 'clear') {
                weitereProdukte.forEach((produkt) => {
                  if (produkt.ausgewaehlt) {
                    dispatch(actions.updateByName(`euBeratung.versicherungsProduktStruktur.0.produktbausteinNichtVorbelegt.${produkt.index}.ausgewaehlt`, false));
                  }
                });
                aktualisiereBeratungsdokuMeta();
              }
            }}
            name="euBeratung.versicherungsProduktStruktur.0.produktbausteinNichtVorbelegt"
          />

          <If predicate={produktStruktur.freitext.relevant}>
            <FormText
              {...produktStruktur.freitext}
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              name="euBeratung.versicherungsProduktStruktur.0.freitext.value"
              error={produktStruktur.freitext.meldungen ? produktStruktur.freitext.meldungen[0].meldungsVariablen : null}
              rows="5"
              resize="vertical"
            />
          </If>

          <If predicate={produktStruktur.empfehlungAngenommen.relevant}>
            <FormSelect
              {...produktStruktur.empfehlungAngenommen}
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              value={produktStruktur.empfehlungAngenommen.value.id}
              name="euBeratung.versicherungsProduktStruktur.0.empfehlungAngenommen.value.id"
              error={produktStruktur.empfehlungAngenommen.meldungen ? produktStruktur.empfehlungAngenommen.meldungen[0].meldungsVariablen : ''}
            />
          </If>

          <If predicate={parseInt(produktStruktur.empfehlungAngenommen.value.id, 10) === 1}>
            <FormSelect
              {...produktStruktur.empfehlung}
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              labelClassName="colon"
              firstEmpty
              value={produktStruktur.empfehlung.value ? produktStruktur.empfehlung.value.id : ''}
              name="euBeratung.versicherungsProduktStruktur.0.empfehlung.value.id"
              error={produktStruktur.empfehlung.meldungen ? produktStruktur.empfehlung.meldungen[0].meldungsVariablen : ''}
            />

            <FormInput
              {...produktStruktur.konkretisierungEmpfehlung}
              onChange={(e) => dispatch(actions.updateByEvent(e))}
              name="euBeratung.versicherungsProduktStruktur.0.konkretisierungEmpfehlung.value"
            />
          </If>
        </div>

        <Row>
          <Col>
            <PrevNextButton
              className="d-md-none oev-show spk-show"
              onNextClick={handleNextClick}
            />
          </Col>
        </Row>
      </Col>
      <SummingUp bannerImg={getBannerFileName}>
        <SummingUpInhalt />
        <BegleitdatenModalNeuesModell onChange={validateOnChange} />
      </SummingUp>
    </Row>
  );
};

export default EmpfehlungBerater;
